import { 
  Box, 
  Button, 
  VStack, 
  Text, 
  FormControl, 
  FormLabel, 
  Input,
  FormErrorMessage,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useAddDepartment } from "../../services/configurationService";
import { FiUsers } from "react-icons/fi";

const AddDepartment = ({ closeModal, editDept, todo, editDepartmentPayload, editDepartmentIsLoading, refetchGetDepartment }) => {
  const [inputData, setInputData] = useState({ name: "" });
  const [errors, setErrors] = useState({});
  
  const { addDepartmentIsLoading, addDepartmentPayload } = useAddDepartment((res) => {
    refetchGetDepartment();
    closeModal();
  });

  const validateForm = () => {
    const newErrors = {};
    if (!inputData.name.trim()) {
      newErrors.name = "Department name is required";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!validateForm()) return;

    const payload = {
      id: todo === "edit" ? editDept?.id : "",
      name: inputData.name.trim(),
    };

    if (todo === "new") {
      addDepartmentPayload(payload);
    } else {
      editDepartmentPayload(payload);
    }
  };

  useEffect(() => {
    if (editDept?.name) {
      setInputData({ name: editDept.name });
    }
  }, [editDept]);

  return (
    <Box>
      <form onSubmit={handleSubmit}>
        <VStack spacing={6} align="stretch">
          {/* Header */}
          <VStack spacing={2} align="center">
            <Box
              p={3}
              borderRadius="12px"
              bg="blue.50"
              color="blue.600"
              border="1px solid"
              borderColor="blue.200"
            >
              <FiUsers size={24} />
            </Box>
            <VStack spacing={1}>
              <Text fontSize="lg" fontWeight="600" color="gray.900">
                {todo === "edit" ? "Edit" : "Add"} Department
              </Text>
              <Text fontSize="sm" color="gray.500" textAlign="center">
                {todo === "edit" ? "Update department information" : "Enter department details"}
              </Text>
            </VStack>
          </VStack>

          {/* Form Fields */}
          <FormControl isInvalid={!!errors.name}>
            <FormLabel fontSize="sm" fontWeight="500" color="gray.700">
              Department Name
            </FormLabel>
            <Input
              placeholder="Enter department name"
              value={inputData.name}
              onChange={(e) => setInputData({ ...inputData, name: e.target.value })}
              borderRadius="12px"
              borderColor="gray.200"
              _focus={{ borderColor: "blue.500", boxShadow: "0 0 0 1px var(--chakra-colors-blue-500)" }}
              _hover={{ borderColor: "gray.300" }}
              size="lg"
            />
            <FormErrorMessage>{errors.name}</FormErrorMessage>
          </FormControl>

          {/* Submit Button */}
          <Button
            type="submit"
            colorScheme="blue"
            size="lg"
            borderRadius="12px"
            fontWeight="600"
            isLoading={addDepartmentIsLoading || editDepartmentIsLoading}
            loadingText={todo === "edit" ? "Updating..." : "Adding..."}
            _hover={{ transform: "translateY(-1px)", boxShadow: "lg" }}
            transition="all 0.2s"
          >
            {todo === "edit" ? "Update Department" : "Add Department"}
          </Button>
        </VStack>
      </form>
    </Box>
  );
};

export default AddDepartment;
